const postAddDocumentServices = {
  toastr: 'Documento adicionado',
  toastr1:'O documento foi adicionado com sucesso'
};

export default postAddDocumentServices;
